import { render } from "./payeeEntityView.vue?vue&type=template&id=e5ccdf52"
import script from "./payeeEntityView.vue?vue&type=script&lang=js"
export * from "./payeeEntityView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__